// Api Localhost
//export const ROOT_PATH = "http://localhost:5000/api/";
// Api Servidor
export const ROOT_PATH = "https://sised.com.co:3000/api/"; 
